import { Property, Place, Area, Region } from '@iotv/datamodel-core';
import { getViewDefinitionFromUserAttributes, getViewDefintionFromObject } from '../factories/AttributeDefinitions';
export const getRegionViewDefinition = () => {
    const regionAttrs = new Region({}).getUserAttributes();
    return getViewDefinitionFromUserAttributes(regionAttrs);
};
export const getPropertyViewDefinition = () => {
    return getViewDefintionFromObject(new Property({}));
};
export const getPlaceViewDefinition = () => {
    return getViewDefinitionFromUserAttributes(new Place({}).getUserAttributes());
};
export const getAreaViewDefinition = () => {
    return getViewDefinitionFromUserAttributes(new Area({}).getUserAttributes());
};
